package com.essntl.uikit.components.input.label

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun EsInputLabel(
    label: String,
    modifier: Modifier = Modifier,
) {
    Text(
        text = label,
        color = MaterialTheme.esColorScheme.textPrimary,
        style = MaterialTheme.esTypography.p2Regular14,
        modifier = modifier,
    )
}